import { PreloadedQuery } from 'react-relay';
import type { VariablesOf } from 'relay-runtime';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import ProjectGroupPermissionsSettingsAggQuery, {
	type ProjectGroupPermissionsSettingsAggQuery as ProjectGroupPermissionsSettingsAggQueryType,
} from '../../components/GroupPermissionsSettings/__generated__/ProjectGroupPermissionsSettingsAggQuery.graphql';

export const projectGroupsSettingsResource: RouteResource<
	PreloadedQuery<ProjectGroupPermissionsSettingsAggQueryType, Record<string, unknown>>
> = createRelayResource<ProjectGroupPermissionsSettingsAggQueryType>({
	getQuery: (_routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		const variables: VariablesOf<ProjectGroupPermissionsSettingsAggQueryType> = {
			containerId: context.collabContext?.contextId ?? '',
			isM3GroupPermsEnabled: fg('townsquare_m3_group_permissions'),
		};

		return {
			query: ProjectGroupPermissionsSettingsAggQuery,
			variables,
			environment: getAggRelayEnvironment(),
		};
	},
});
